// Vite adds some functionality for import.meta - so we reference the types here:
/// <reference types="vite/client" />

import "@hotwired/turbo-rails";
import { Turbo } from "@hotwired/turbo-rails"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Default of 500ms is too long, reduce so users can see a direct result of their action
Turbo.config.drive.progressBarDelay = 200;
// Turbo has no built-in way to leave a <turbo-frame> after a successful
// form submission (a redirect without a matching frame throws). Controllers
// answer with this action to navigate the whole page.
Turbo.StreamActions.visit = function () {
  Turbo.visit(this.getAttribute("url"))
}
// Turbo.session.drive = false // Disable turbo

// Stimulus controllers
import "~/controllers";

// ActionCable Channels
import "~/channels";

// Enable :active styling on tap in iOS Safari. iOS only fires :active on
// elements when a touchstart listener is bound somewhere in the tree.
// Marked passive so it does not block scroll handling.
document.addEventListener("touchstart", () => {}, { passive: true });
